/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { inject as service } from '@ember/service';
import DS from 'ember-data';
import { all, any } from 'cio/app-models/conditions/group';
import { DataSourceLabelVariant } from 'cio/utils/data-source-label';
import CioConditionViewerBase, { CioConditionViewerBaseArgs } from 'cio/components/cio-condition-viewer-base';
import RelationshipCondition from 'cio/app-models/conditions/relationship';

interface CioConditionViewerRelationshipArgs extends CioConditionViewerBaseArgs {
  condition: RelationshipCondition;
  depth?: number;
  labelVariant?: DataSourceLabelVariant;
  labelTruncate?: boolean;
}

const GROUP_TYPES = {
  [all]: 'all',
  [any]: 'at least one',
};

export default class CioConditionViewerRelationship extends CioConditionViewerBase<CioConditionViewerRelationshipArgs> {
  @service store!: DS.Store;

  get hasFilter() {
    return this.args.condition.filters.length > 0;
  }

  get filterOperator() {
    return GROUP_TYPES[this.args.condition.filterOperator];
  }

  get objectName() {
    if (this.args.condition.typeId == null) {
      return 'object';
    }

    let objectType = this.store.peekRecord('object-type', this.args.condition.typeId);
    return objectType?.name ?? 'object';
  }
}
